<div class="modal-header">
  <h2 class="modal-title">{{ azione }} monitoraggio</h2>
  <button
    class="close"
    type="button"
    aria-label="Chiudi"
    (click)="activeModal.close()"
    tabindex="0"
  >
    <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
  </button>
</div>
<div class="modal-body">
  <form class="form" role="form" [formGroup]="criteriaForm">
    <div class="form-row">
      <div class="form-group col-md-4">
        <label for="idTipoIntervento">Tipo intervento</label>
        <select
          class="form-control"
          formControlName="idTipoIntervento"
          id="idTipoIntervento"
        >
          <option [ngValue]="null">Seleziona un'opzione...</option>
          <option
            *ngFor="let item of datalist.tipologiaIntervento"
            [ngValue]="item.id"
          >
            {{ item.descrizione }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-4">
        <label for="efficienza">Efficienza</label>
        <select
          class="form-control"
          formControlName="efficienza"
          id="efficienza"
        >
          <option [ngValue]="null">Seleziona un'opzione...</option>
          <option
            *ngFor="let item of datalist.fascePercentuali"
            [ngValue]="item.id"
          >
            {{ item.descrizione }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-4">
        <label for="efficacia">Efficacia</label>
        <select class="form-control" formControlName="efficacia" id="efficacia">
          <option [ngValue]="null">Seleziona un'opzione...</option>
          <option
            *ngFor="let item of datalist.fascePercentuali"
            [ngValue]="item.id"
          >
            {{ item.descrizione }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-4">
        <label for="enteEsecutore">Ente esecutore</label>
        <input
          class="form-control"
          id="enteEsecutore"
          formControlName="enteEsecutore"
          type="text"
        />
      </div>
      <div class="form-group col-md-4">
        <app-toolkit-datepicker
          id="dataEsecuzione"
          label="Data ultima ispezione"
          formControlName="dataEsecuzione"
          [disabled]="criteriaForm.controls['dataEsecuzione'].disabled"
        >
        </app-toolkit-datepicker>
      </div>
      <div class="form-group col-md-4">
        <app-toolkit-datepicker
          id="dataProssimaIspezione"
          label="Data prossima ispezione"
          formControlName="dataProssimaIspezione"
          [disabled]="criteriaForm.controls['dataProssimaIspezione'].disabled"
        >
        </app-toolkit-datepicker>
      </div>
      <div class="form-group col-md-12">
        <label for="linkSchedaMonitoraggio"
          >Link scheda monitoraggio esterna</label
        >
        <input
          *ngIf="canEdit"
          class="form-control"
          id="linkSchedaMonitoraggio"
          formControlName="linkSchedaMonitoraggio"
          type="url"
        />
        <a
          *ngIf="!canEdit"
          id="linkSchedaMonitoraggio"
          href="{{ this.criteriaForm.get('linkSchedaMonitoraggio')?.value }}"
          target="_blank"
        >
          {{ this.criteriaForm.get("linkSchedaMonitoraggio")?.value }}</a
        >
      </div>
      <div class="form-group col-md-12">
        <label for="note">Note</label>
        <textarea
          class="form-control"
          id="note"
          formControlName="note"
        ></textarea>
      </div>
    </div>
  </form>
  <p class="mt-3"><strong>* Campi obbligatori.</strong></p>
</div>
<div class="modal-footer">
  <button
    type="button"
    tabindex="0"
    (click)="activeModal.close()"
    class="btn btn-outline-primary"
  >
    Chiudi
  </button>
  <button
    *ngIf="canEdit"
    type="button"
    tabindex="0"
    (click)="saveMonitoraggio()"
    class="btn btn-primary"
  >
    Salva
  </button>
</div>
